import {ActionableUserEntity, AllowedAction} from './util-interfaces';
import {UserEntityType} from '@app/shared/services/api/user-entity';
export class Contractor implements ActionableUserEntity {
  type = UserEntityType.CONTRACTOR;

  constructor(public id: number, public name: string, public logoUrl: URL, public allowedActions?: AllowedAction[]) { }
}
